module.exports = __webpack_public_path__ + "img/fondo-banner-principal.0636cf4e.png";